/**
 * contiene la información para el manejo de Bases.
 */
export const defaultBases = () => {
    return {
        id: '',
        descripcion:'',
        activo: 1,
        updateBase : false,
        paginadorBase: 5,
        verPaginadorBase: false,
        bases: [],
        bases_ori: []
    }
}

/**
 * contiene la información para el manejo de Äreas.
 */
export const defaultAreas = () => {
    return {
        id: '',
        descripcion:'',
        activo: 1,
        updateArea : false,
        areas: [],
        areas_ori: [],
        paginadorArea: 5,
        verPaginadorArea: false
    }
}

/**
 * contiene la información para el manejo de Bases y áreas.
 */
export const defaultBasesAreas = () => {
    return {
        viewPaginador: true,
        bases_areas: [],
        bases_areas_ori: [],
        bases_areas_sinfil: [],
        paginador: 10,
        seltodos: false,
        visibleTodos: true,
        filtro_bases_areas: null
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedBases: defaultBases(),
    selectedAreas: defaultAreas(),
    selectedBasesAreas: defaultBasesAreas()
    
    /* bases_areas: [],
    viewPaginador: true,
    paginador: 10, */
}